// Mock data for Breakdance Crew Website

export const navItems = [
  { label: 'Accueil', href: '/' },
  { label: 'À Propos', href: '/a-propos' },
  { label: 'Équipe', href: '/equipe' },
  { label: 'Galerie', href: '/galerie' },
  { label: 'Vidéos', href: '/videos' },
  { label: 'Événements', href: '/evenements' },
  { label: 'Partenaires', href: '/partenaires' },
  { label: 'Contact', href: '/contact' }
];

export const heroContent = {
  title: 'BREAKDANCE CREW',
  subtitle: 'Passion, Énergie, Culture',
  videoUrl: 'https://customer-assets.emergentagent.com/job_6e5a3b07-0a07-4f17-b18b-4bfb1d182dba/artifacts/08xvldk7_break%20dance%20video%20acceuil.mp4',
  primaryCTA: 'Découvrir nos événements',
  secondaryCTA: 'Voir les vidéos'
};

export const features = [
  {
    id: 1,
    title: 'Équipe Passionnée',
    description: 'Des danseurs professionnels passionnés par le breakdance et la culture hip-hop',
    icon: 'users'
  },
  {
    id: 2,
    title: 'Événements Réguliers',
    description: 'Battles, cours et spectacles tout au long de l\'année pour tous les niveaux',
    icon: 'calendar'
  },
  {
    id: 3,
    title: 'Galerie & Vidéos',
    description: 'Découvrez nos meilleurs moments et performances capturés en images et vidéos',
    icon: 'image'
  }
];

export const events = [
  {
    id: 1,
    title: 'Vibrations Urbaines - Exposition',
    date: '10 Déc 2025 - 23 Jan 2026',
    location: 'Dévorah',
    description: 'Une exposition unique célébrant la culture urbaine et le breakdance. Venez découvrir l\'art du mouvement à travers des photos, vidéos et performances live.',
    imageUrl: 'https://customer-assets.emergentagent.com/job_6e5a3b07-0a07-4f17-b18b-4bfb1d182dba/artifacts/dj4bztd5_IMG_6797.jpeg',
    featured: true
  },
  {
    id: 2,
    title: 'Battle des Élèves',
    date: '12 Déc 2025',
    location: 'Salle de l\'Alagnier',
    description: 'Breaking 3vs3 Junior & All Style 1vs1. Un événement gratuit organisé par Zero Un Production. Horaires: 18h30 - 20h30',
    imageUrl: 'https://customer-assets.emergentagent.com/job_6e5a3b07-0a07-4f17-b18b-4bfb1d182dba/artifacts/zp4uk3x1_IMG_6800.jpeg',
    featured: true
  }
];

export const teamMembers = [
  {
    id: 1,
    name: 'Membre 1',
    role: 'B-Boy / Instructeur',
    imageUrl: 'https://customer-assets.emergentagent.com/job_6e5a3b07-0a07-4f17-b18b-4bfb1d182dba/artifacts/j5qd8qyk_IMG_6801.jpeg'
  },
  {
    id: 2,
    name: 'Membre 2',
    role: 'B-Boy / Chorégraphe',
    imageUrl: 'https://customer-assets.emergentagent.com/job_vibes-urbaines/artifacts/53e7osdn_IMG_6798.jpeg'
  }
];

export const communitySection = {
  title: 'Rejoignez Notre Communauté',
  description: 'Que vous soyez débutant ou confirmé, rejoignez notre crew et vivez la passion du breakdance avec nous. Participez à nos événements, battles et cours réguliers.',
  ctaText: 'Contactez-nous'
};